import styled from 'styled-components'
import backgroundImg from '../../assets/images/login-background.png'

export const LoginWrapper = styled.main`
  width: 100vw;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  align-items: center;
  background-image: linear-gradient(
      89.59deg,
      #ff990095 0.92%,
      rgba(255, 197, 109, 0) 57.34%,
      rgba(255, 255, 255, 0) 99.64%
    ),
    url(${backgroundImg});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

`

export const LoginContainer = styled.div`
  position: relative;
  width: 26.2rem;
  padding: 0 2.3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${props => props.theme.container};
  @media (max-width: 1300px) {
 
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%, -50%);
    width: 22rem;
    padding: 0 1rem;

    button{
      width: 100% !important;
    }
    
  }
`
export const LoginDivider = styled.div`
  padding-left: 10vw;
`

export const CodeGoBack = styled.div`
  top: 1rem;
  left: 1rem;
  cursor: pointer;
  /* svg {
    width: 30px;
    height: 30px;
  } */
`
export const PhoneNumberError = styled.div`
  position: absolute;
  font-size: 0.7rem;
  color: red;
`
